import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EHRInstance = {
    _v1: {
        getEhrInstance: { method: HttpMethod.GET, path: '/v1/get-ehr-instance' },
        deleteInstance: { method: HttpMethod.POST, path: '/v1/delete-instance' },
        syncOrdersFromPathways: { method: HttpMethod.POST, path: '/v1/sync-orders-from-pathways' },
        copyOrderConfigsFromEhrInstance: { method: HttpMethod.POST, path: '/v1/copy-order-configs-from-ehr-instance' },
        getCertData: { method: HttpMethod.POST, path: '/v1/get-cert-data' },
        getQuaiEhrInstances: { method: HttpMethod.GET, path: '/v1/get-quai-ehr-instances' },
    }
};
//# sourceMappingURL=api-def.js.map